import React, { useMemo, useRef, useState } from 'react'
import { useNavigate, Link } from 'react-router-dom';
import * as PR from "../../prime-react/index";
import { chatIcon } from "../../assets/images/index";
import AppliedFilter from './AppliedFilter';
import SearchFilter from './SearchFilter';
import { getAlertResponses, getAlertDetails } from '../../services/api';
import { useDispatch, useSelector } from 'react-redux';
import { RAW_FILTER_DATA } from '../../shared/common';
import { DateFormat, dateTimeFormat, formatTime, getSportIcon, rowsPerPage, cleanData } from '../../utils/reuse';
import { authActions } from '../../store/auth';
import ImageDisplay from '../ImageDisplay';
import AlertsSearchId from './AlertSearchId';
import { isEmpty, some } from 'lodash';
import { useToast } from '../../context/ToastContext';
import ChatDialog from '../Chat/ChatDialog';


const AlertsGrid = ({activeIndex, totalCount, offset, limit, sortValue, sortOrder, tabChangeHandler, getSelectedFilters, selectedFilters,handlePageChange, exportCSV, exportLoading, loading, tagId, tagName}) => {
    const dispatch = useDispatch();
    const { showToast } = useToast();
    const alerts = useSelector(state => state.auth.alerts);
    const sortKey = useRef({field:'createdOnRaw',value:!!sortValue ? 1 : -1})
    const pathname = window.location.pathname;
    const sessionData = useSelector(state => state.auth.sessionData);
    const isExport =  useSelector(state => state.auth.exportPermission);
    const headers = useMemo(() => {
        return { sessionid: sessionData.sessionId };
    }, [sessionData.sessionId]);
    const groupID = sessionData.groupID;
    const isMember = useSelector(state => state.auth.role) === 'member';
    const isAnalyst = useSelector(state => state.auth.role) === 'analyst';
    const isManagedMember = useSelector(state => state.auth.role) === 'managedmember';
    const [updateSelectedFilters, setUpdateSelectedFilters] = useState(selectedFilters);
    const [respondedVisible, setRespondedVisible] = useState(false);
    const [notRespondedVisible, setNotRespondedVisible] = useState(false);
    const [suspiciousVisible, setSuspiciousVisible] = useState(false);

    const [chatVisible, setChatVisible] = useState(false);
    const [filterDialogVisible, setFilterDialogVisible] = useState(false);
    const [filterVisible, setFilterVisible] = useState(true);
    const [chatInfo,setChatInfo] = useState({
        alertID:'',
        alertName:'',
        groupID:'',
        conversationID:'',
        legacyID: '',
        createdByGroupName: '',
        groupImage: '',
        alertDescription: '',
        responseDescription: '',
        isResponseChat: false
    });

    const navigate = useNavigate();
    const gotoAlertDetails=(alertID)=>{
        getAlertDetails(alertID, headers, dispatch, ({result, error, data})=>{
            const alertDetailsData = {result, error, data};
            if(result==='SUCCESS' && (data && data?.alertID)) {
                localStorage.setItem('pageRefreshed', false);
                navigate("/alert-details/" + (data?.legacyID ? data.legacyID: data.alertID) , {state: {alertDetailsData, tagId, tagName}});
            } else {
                showToast("error", "Alert ID is not found");
            }
        });
    }
    const gotoAlertDetailsResponses=(legacyID, responseID)=>{
        setRespondedVisible(false)
        setSelectedRowData({})
        setRespondedQuery('')
        localStorage.setItem('pageRefreshed', false);
        setTimeout(() => {
            navigate("/alert-details/" + legacyID, {state:{responseID}});
        }, 500)
    }
    const setFilters = (data) => {
        getSelectedFilters(data)
        tabChangeHandler(activeIndex,data)
    }
    const keywordSearchHandler = (keyword) => {
        if (!keyword) return;
        const updatedFilters = !isEmpty(selectedFilters) ? selectedFilters : {
          combinedStatus: [],
          alertStatus: [],
          caseStatus: [],
          tags: [],
          sports: [],
          eSportsTitles: [],
          tournamentLevels: [],
          alertType: [],
          responseType: [],
          company: [],
          date: { date: "", dateRange: "" },
          eventDate: { date: "", dateRange: "" },
          tournament: [],
          gender: [],
          location: [],
          customerLocations: [],
          reportType: [],
          receiver: [],
          channel: [],
          timeOfBet: [],
          stateOfBet: [],
          maxBets: [],
          timeOfAlert: [],
          keyword
        };
        const newFilters = { ...updatedFilters, keyword };
      
        setUpdateSelectedFilters(newFilters);
        setFilters(newFilters);
      };
      
    const filterHideShow = () => {
        setFilterVisible(!filterVisible);
    };



    const setResponseCount = (id, responseCount) => {
        const alert = alerts.find(alert => alert.alertID === id)
        const updatedAlert = { ...alert, ...responseCount }
        const updatedAlerts = alerts.map(alert => alert.alertID === id ? updatedAlert:alert)

        dispatch(authActions.updateAlertsList(updatedAlerts))
    }

    const changeActiveConversation = (id, isActive) => {
        const alert = alerts.find(alert => alert.alertID === id)
        const updatedAlert = { ...alert, activeConversation: isActive };
        const updatedAlerts = alerts.map(alert => alert.alertID === id ? updatedAlert : alert);

        dispatch(authActions.updateAlertsList(updatedAlerts));
    }

    const [responsesPopupLoading, setResponsesPopupLoading] = useState(false)
    const getAlertResponsesHandler = (id , legacyID) => {
        setResponsesPopupLoading(true)
        getAlertResponses(id, headers, dispatch, response => {
            if (response.result === 'SUCCESS' && response.data) { 
                let data = {alertID: id, legacyID}
                const alertResponses = response.data?.sort((a, b) => a.respondingGroup.localeCompare(b.respondingGroup));
                
                const respondedInfo = alertResponses.filter(response => response.responseID)
                const notRespondedInfo = alertResponses.filter(response => !response.responseID)

                data["respondedInfo"] = respondedInfo
                data["respondedCount"] = respondedInfo.length

                const claimedSuspicious = respondedInfo.filter(response => response.responseType === "offered and suspicious")
                
                data["suspiciousInfo"] = claimedSuspicious
                data["suspiciousCount"] = claimedSuspicious.length
                
                data["notRespondedInfo"] = notRespondedInfo
                data["notRespondedCount"] = notRespondedInfo.length

                setResponseCount(id,{
                    responded: data["respondedCount"],
                    notResponded: data["notRespondedCount"],
                    suspicious: data["suspiciousCount"],
                })

                setSelectedRowData(data)
                setResponsesPopupLoading(false)
            }else{
                setResponsesPopupLoading(false)
            }
        })
    }

    const eventID = (rowData) => {
        return (
            <div className="flex align-items-center gap-3">
                <div className='sports-icon'>{getSportIcon(rowData?.sportID + 'b')}</div>
                <div className="event-column">
                    <p>{rowData.alertName}</p>
                    <span>ID: {rowData.legacyID}</span>
                </div>
            </div>
        );
    };

    const createdAtDateDisplay = (rowData) => {
        return (
            <div className="flex align-items-center gap-3">
                <div className="event-column">
                    <p>{DateFormat(rowData.createdAt)}</p>
                    <span>{formatTime(rowData.createdAt)}</span>
                </div>
            </div>
        );
    };
    const [rawFilterData] = useState(RAW_FILTER_DATA);

    const status = (rowData) => {
        const alertStatus = rawFilterData.statusFilter?.find(item => item.id === rowData.alertStatus)
        const caseStatus = rawFilterData.caseStatus?.find(item => item.id === rowData.caseStatus)

        const currentLabel = caseStatus?.name ?`${alertStatus?.name}: ${caseStatus?.name}`: alertStatus?.name
        const additionalStyle = alertStatus?.style || '';

        return (
            <div className={`status ${additionalStyle}`}>
                {currentLabel}
            </div>
        )
    };

    const alertTypeHandler = (row) => {
      return (
        <div>{rawFilterData.alertTypeFilter.find(item => item.id === row.alertType)?.name}</div>
      )
    };

    const [selectedRowData, setSelectedRowData] = useState({});
    const response = (rowData) => {
        const disableStyle = rowData.responded>0 ?'':'disableStyle'
        return (
            <>
                <div className="flex align-items-center gap-2">
                    <div className={`response ${disableStyle}`} onClick={() => {
                            if(rowData.responded>0){
                                setRespondedVisible(true)
                                getAlertResponsesHandler(rowData.alertID, rowData?.legacyID)
                            }
                        }}
                    >
                        <i className="pi pi-check"></i> {rowData.responded}
                    </div>
                    <div className={`response not-respond ${disableStyle}`} onClick={() => {
                            if(rowData.responded>0 && rowData.notResponded>0){
                                setNotRespondedVisible(true)
                                getAlertResponsesHandler(rowData.alertID, rowData?.legacyID)
                            }
                        }}
                    >
                        <i className="pi pi-times"></i> <span className='text-blur'>{rowData.notResponded}</span>
                    </div>
                    <div className={`response suspicious ${disableStyle}`} onClick={() => {
                            if(rowData.responded>0 && rowData.suspicious>0){
                                setSuspiciousVisible(true)
                                getAlertResponsesHandler(rowData.alertID, rowData?.legacyID)
                            }
                        }}
                    >
                        <i className="pi pi-info-circle"></i> <span className='text-blur'>{rowData.suspicious}</span>
                    </div>
                    {!isManagedMember && <div
                        className={`response chat
                            ${(isAnalyst && sessionData.groupID === rowData.createdByGroupID) ?  rowData?.activeConversation ? 'non-clickable' : 'disabled' : ''}
                            ${isMember && (!rowData.conversationExists) ? 'disabled' : 'clickable'}
                            ${rowData?.activeConversation ? 'active' : ''}
                        `}
                    >
                        <PR.Image src={chatIcon} alt="Chat ID" className="icon" onClick={() => {
                            setChatVisible(true)

                            const id = isMember ? groupID : rowData.createdByGroupID
                            setChatInfo(prev => ({
                                ...prev,
                                groupID:id,
                                alertID:rowData?.alertID,
                                alertName: rowData?.alertName,
                                legacyID: rowData?.legacyID,
                                createdByGroupName: rowData?.createdByGroupName,
                                groupImage: rowData?.groupImage,
                                alertDescription: '',
                                responseDescription: '',
                                isResponseChat: false
                            }))
                        }}/>
                    </div>}
                </div>
            </>
        );
    };
    const action = (rowData) => {
        return (
            <div className="flex flex-wrap">
                <Link
                    to={`/alert-details/${rowData.legacyID || rowData.alertID}`}
                    onClick={(e) => {
                        if (!e.ctrlKey && !e.metaKey && e.button !== 1) {
                            e.preventDefault();
                            gotoAlertDetails(rowData.alertID);
                        }
                    }}
                    className="p-button p-component p-button-secondary p-button-outlined view-details-button"
                    style={{ textDecoration: 'none' }}
                >
                    <span className="p-button-label">View Details</span>
                </Link>
                {(rowData?.alertStatus === 'open') && (rowData.responseRequired || activeIndex === 2) && <span className="response-span flex align-items-center gap-1"><i className="pi pi-info-circle"></i> Response required</span>}
            </div>
        );
    };

    const header = (
        <>
            <div className="status-filter-section flex gap-2">
                <AlertsSearchId headers={headers} goTo={gotoAlertDetails} disabledField={loading || exportLoading} keywordSearchHandler={keywordSearchHandler}/>
                <PR.Button className={`search-filters-button filter-icon ${cleanData(updateSelectedFilters) ? 'search-filter-applied': null}`} iconPos='left' outlined onClick={() => setFilterDialogVisible(true)} disabled={loading || exportLoading}>
                    <span className="label">Search Filters</span>
                </PR.Button> 
                {((isExport && activeIndex === 0) || (isAnalyst && pathname === "/home")) && 
                <PR.Button className="search-filters-button export-icon" iconPos='left' outlined onClick={exportCSV} disabled={loading || exportLoading}>
                    <i className='pi pi-upload export-icon'></i>
                    <span className="label">Export</span>
                </PR.Button>}
            </div>
            {(some(updateSelectedFilters, v =>!isEmpty(v))) &&
                <AppliedFilter selectedFilters={updateSelectedFilters} setFilters={setFilters} filterVisible={filterVisible} filterHideShow={filterHideShow} />
            }
        </>
    );
    const respondedFooterContent = (
        <div>
            <PR.Button 
                label="Close" 
                onClick={() => {
                    setRespondedVisible(false)
                    setSelectedRowData({})
                    setRespondedQuery('')
                }} 
                outlined 
                className="logout-btns" />
        </div>
    );

    const notRespondedFooterContent = (
        <div>
            <PR.Button 
                label="Close" 
                onClick={() => {
                    setNotRespondedVisible(false)
                    setSelectedRowData({})
                    setNotRespondedQuery('')
                }} 
                outlined 
                className="logout-btns" />
        </div>
    );

    const suspiciousFooterContent = (
        <div>
            <PR.Button 
                label="Close"
                onClick={() => {
                    setSuspiciousVisible(false)
                    setSelectedRowData({})
                    setSuspiciousQuery('')
                }} 
                outlined className="logout-btns" />
        </div>
    );


    const [respondedQuery, setRespondedQuery] = useState('');

    const filteredRespondedInfo = selectedRowData?.respondedInfo?.filter(company =>
        company.respondingGroup.toLowerCase().includes(respondedQuery.toLowerCase())
    );

    const [notRespondedQuery, setNotRespondedQuery] = useState('');

    const filteredNotRespondedInfo = selectedRowData?.notRespondedInfo?.filter(company =>
        company.respondingGroup.toLowerCase().includes(notRespondedQuery.toLowerCase())
    );

    const [suspiciousQuery, setSuspiciousQuery] = useState('');

    const filteredSuspiciousInfo = selectedRowData?.suspiciousInfo?.filter(company =>
        company.respondingGroup.toLowerCase().includes(suspiciousQuery.toLowerCase())
    );

    const showCompanyColumn = () => {
        return (
            (activeIndex!==3 && (pathname ==='/alerts') && (isMember || isManagedMember) ) ||
            (isAnalyst)
        )
    }

    const getReference = (count) => {
        return count > 1 ? 'members':'member'
    }
    const sortAlertType = (v) => {
        const value = sortKey.current.value===1?-1:1
        sortKey.current={field:'alertType', value}
        let arr = [...alerts]
        arr.sort((a,b)=>  v ===1 ? a.alertType.localeCompare(b.alertType) : b.alertType.localeCompare(a.alertType) )
        dispatch(authActions.updateAlertsList(arr));
    }



    return (
        <>
            <div className="grid grid-nogutter">
                <div className="card col-12 relative">
                    <PR.DataTable 
                        value={alerts} 
                        stripedRows 
                        className="data-table"
                        paginator
                        lazy
                        onPage={handlePageChange}
                        first={offset}
                        totalRecords={totalCount}
                        rows={limit}
                        rowsPerPageOptions={rowsPerPage}
                        header={header} 
                        tableStyle={{ minWidth: '50rem' }}
                        paginatorTemplate={{layout: 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown', 'PageLinks': (options) => {
                            if(options.currentPage+2 >= options.page && options.currentPage-2 <= options.page )return options.element
                            else if (0 === options.page) return options.element
                            else if(3 >= options.page) return <>.</>
                            else if (options.totalPages-1 === options.page) return options.element
                            else if(options.totalPages-4 <= options.page) return <>.</>
                        } }}
                        pageLinkSize={Math.ceil(totalCount/limit)}
                        sortField={sortKey.current.field}
                        sortOrder={sortKey.current.value}
                        onSort={({sortField, sortOrder:v})=>{sortField==="createdOnRaw"&& sortOrder(); sortField === 'alertType' && sortAlertType(v) }}
                    >
                        <PR.Column body={eventID} header="Event" style={{width:"30%"}}></PR.Column>
                        <PR.Column 
                            body={createdAtDateDisplay}
                            header="Created" 
                            sortable
                            sortField="createdOnRaw"
                            style={{width:"10%"}}
                        ></PR.Column>
                        <PR.Column body={alertTypeHandler} header="Type" sortable sortField="alertType"></PR.Column>
                        {showCompanyColumn() && <PR.Column field="createdByGroupName" header="Company" className='capitalize'></PR.Column>}
                        <PR.Column body={status} header="Status"></PR.Column>
                        <PR.Column body={response} header="Response"></PR.Column>
                        <PR.Column body={action} header="Action" className="last-column"></PR.Column>
                    </PR.DataTable>
                </div>
            </div>
            {/* Members Responded Dialog */}
            {responsesPopupLoading && respondedVisible?(
                <div className="loading chat-loading">
                    <i className="pi pi-spin pi-spinner"></i>
                </div>
            ):(<PR.Dialog visible={respondedVisible} footer={respondedFooterContent} className="logout-dialog response-dialog" onHide={() => setRespondedVisible(false)} closeOnEscape="true" blockScroll="true">
                {/****  Members Responded ****/}
                <div className="dialog-header">
                    <div className='flex align-items-center justify-content-between mb-5'>
                        <h2>{selectedRowData?.respondedCount} {getReference(selectedRowData?.respondedCount)} responded</h2>
                        <span className='suspicious-span'>{selectedRowData?.suspiciousCount} claimed Suspicious</span>
                    </div>
                    <span className="p-input-icon-left search-field">
                        <i className="pi pi-search" />
                        <PR.InputText
                            placeholder="Search"
                            value={respondedQuery} 
                            onChange={(e) => setRespondedQuery(e.target.value)} 
                        />
                    </span>
                </div>
                <div className="dialog-body-section">

                    {filteredRespondedInfo?.map((company, index) => {
                        return (
                            <div key={index} className="flex align-items-center member-response-list justify-content-between">
                                <div className='left'>
                                    <ul className='flex list-none align-items-center gap-2'>
                                        <li className='flex align-items-center gap-2'>
                                            <ImageDisplay profileImage={company?.groupImage} type="group" key={company?.respondingGroupID}/> 
                                            <span title={company.respondingGroup}>{company.respondingGroup?.length > 20 ? company.respondingGroup?.slice(0, 20)+'..': company.respondingGroup}</span>
                                        </li>
                                        <li>|</li>
                                        <li>{dateTimeFormat(company.createdAt)}</li>
                                    </ul>
                                </div>
                                <div className='right flex align-items-center'>
                                    <span className={(company.responseType === 'offered and suspicious')?'suspicious':null}>{company.responseType}</span> <i className="pi pi-chevron-right" onClick={() => gotoAlertDetailsResponses(selectedRowData?.legacyID,company?.responseID )}></i>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </PR.Dialog>)}

            {/* Members Not Responded Dialog */}
            {responsesPopupLoading && notRespondedVisible?(
                <div className="loading chat-loading">
                    <i className="pi pi-spin pi-spinner"></i>
                </div>               
            ):(<PR.Dialog visible={notRespondedVisible} footer={notRespondedFooterContent} className="logout-dialog response-dialog" onHide={() => setNotRespondedVisible(false)} closeOnEscape="true" blockScroll="true">

                {/* Members Not Responded  */}
                <div className="dialog-header">
                    <div className='flex align-items-center justify-content-between mb-5'>
                        <h2>{selectedRowData?.notRespondedCount} {getReference(selectedRowData?.notRespondedCount)} not responded</h2>
                    </div>
                    <span className="p-input-icon-left search-field">
                        <i className="pi pi-search" />
                        <PR.InputText 
                            placeholder="Search"
                            value={notRespondedQuery} 
                            onChange={(e) => setNotRespondedQuery(e.target.value)} 
                        />
                    </span>
                </div>
                <div className="dialog-body-section">
                    {filteredNotRespondedInfo?.map((company, index) => {
                        return (
                            <div key={index} className='not-responded-list'>
                                <ImageDisplay profileImage={company?.groupImage} type="group" key={company?.respondingGroupID}/> <span>{company.respondingGroup}</span>
                            </div>
                        )
                    })}
                </div> 
            </PR.Dialog>)}

            {/* Members Claimed Suspicious Dialog */}
            {responsesPopupLoading && suspiciousVisible?(
                <div className="loading chat-loading">
                    <i className="pi pi-spin pi-spinner"></i>
                </div>
            ):(<PR.Dialog visible={suspiciousVisible} footer={suspiciousFooterContent} onHide={() => setSuspiciousVisible(false)} className="logout-dialog response-dialog" closeOnEscape="true" blockScroll="true">
                {/* Members Claimed Suspicious  */}
                <div className="dialog-header">
                    <div className='flex align-items-center justify-content-between mb-5'>
                        <h2>{selectedRowData?.suspiciousCount} {getReference(selectedRowData?.suspiciousCount)} claimed Suspicious</h2>
                    </div>
                    <span className="p-input-icon-left search-field">
                        <i className="pi pi-search" />
                        <PR.InputText 
                            placeholder="Search"
                            value={suspiciousQuery}
                            onChange={(e) => setSuspiciousQuery(e.target.value)} 
                        />
                    </span>
                </div>
                <div className="dialog-body-section">
                    {filteredSuspiciousInfo?.map((company, index) => {
                        return (
                            <div key={index} className="flex align-items-center member-response-list justify-content-between">
                                <div className='left'>
                                    <ul className='flex list-none align-items-center gap-2'>
                                        <li className='flex align-items-center gap-2'>
                                        <ImageDisplay profileImage={company?.groupImage} type="group" key={company?.respondingGroupID}/> <span>{company.respondingGroup}</span></li>
                                        <li>|</li>
                                        <li>{dateTimeFormat(company.createdAt)}</li>
                                    </ul>
                                </div>
                                <div className='right flex align-items-center'>
                                    <span className='suspicious'>Offered and Suspicious</span> <i className="pi pi-chevron-right" onClick={() => gotoAlertDetailsResponses(selectedRowData?.legacyID,company?.responseID )}></i>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </PR.Dialog>)}
            {/* Conversation Dialog */}
            <ChatDialog
                visible={chatVisible}
                onHide={() => {
                    setChatVisible(false);
                    setChatInfo({
                        alertID:'',
                        alertName:'',
                        groupID:'',
                        conversationID:'',
                        legacyID: '',
                        createdByGroupName: '',
                        groupImage: '',
                        alertDescription: '',
                        responseDescription: '',
                        isResponseChat: false
                    });
                }}
                chatInfo={chatInfo}
                conversationClicked={true}
                onUpdateChatReadSuccess={(info, responseData) => {
                    changeActiveConversation(info?.alertID, responseData?.activeConversation);
                }}
            />
            <AlertsSearchFilter 
                filterDialogVisible={filterDialogVisible}
                setFilterDialogVisible={setFilterDialogVisible}
                setFilters={setFilters}
                alertsActiveIndex={activeIndex}
                selectedFilters={updateSelectedFilters}
            />
        </>
    );
};
export const AlertsSearchFilter = ({alertsActiveIndex, filterDialogVisible,setFilterDialogVisible,setFilters,selectedFilters}) => {
    const [rawFilterData] = useState(RAW_FILTER_DATA);
    return (
        <>
            {/* Filter Modal Dialog */}
            <PR.Dialog visible={filterDialogVisible} onHide={() => setFilterDialogVisible(false)} className="response-dialog filter-dialog" closeOnEscape="true" blockScroll="true">
                <SearchFilter
                    setFilterDialogVisible={setFilterDialogVisible}
                    setFilters={setFilters}
                    alertsActiveIndex={alertsActiveIndex}
                    staticOptionData={rawFilterData}
                    selectedFilters={selectedFilters}
                    screenType={'alerts'}
                />
            </PR.Dialog>
        </>
    )
}
export default AlertsGrid;
